<script>
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import {required} from "vuelidate/lib/validators";  
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { uuid } from "vue-uuid";
export default {
  mixins: [apibtoast, apigeneric],
  props: ["satdosyaId", "FirmasData"],
  data() {
    return { 
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      Firmalar: [],
      ComboDataArray: [],
      FirmaFiyat:[],
      SatDosyaFirma:[]
    };
  },
  validations:{ 
    Firmalar:{required}, 
  },
  components: {
    Loader,
    Treeselect
  },
  watch: {
    satdosyaId() {},
  },
  methods: {
    onSubmit() { 

      this.$v.$touch();
      if (!this.$v.$invalid) { 

        var FormDataFirma=[] 
        var FormDataFirmaFiyat=[] 
      for(var i=0; i<this.Firmalar.length; i++){
        let uid=uuid.v4()
          FormDataFirma.push({
            Id:uid,
            Dosyaid: this.satdosyaId,
            Firmaid: this.Firmalar[i],
            Degerlendirmeid: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            Kararid: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            Firmaturu: 2, 
          });

           let DosyaFirmaId = this.SatDosyaFirma.filter((notification) =>
          notification.Firmaid.includes(this.Firmalar[i])
          )[0].Id;

          let FirmaFiyatlari = this.FirmaFiyat.filter((notification) =>
          notification.Dosyafirmaid.includes(DosyaFirmaId)
          ); 
              for(var j=0; j<FirmaFiyatlari.length; j++){ 
                    FormDataFirmaFiyat.push({
                      Birimfiyat: FirmaFiyatlari[j].Birimfiyat,
                      Dosyafirmaid: uid,
                      Dosyamalzemeid: FirmaFiyatlari[j].Dosyamalzemeid,
                      Fiyatturu:2, 
                    });
               }
      }

  
        this.ActionsPost({"Service":"satdosyafirma/PostList","Data":FormDataFirma}).then(res => {
                    if(res.Succeeded == true){  

                       this.Post("satdosyafirmafiyat/PostList", FormDataFirmaFiyat).then((res) => {
                        if (res) {   
                          this.$emit("TableUpdate");
                          this.$bvModal.hide("yaklasikmaliyettenaktar");
                        }
                      });
                    }else{ 
                      this.$toast.error(this.$t('ToasMessage.PostNegatif'));    
                    } 
                     
                }); 

        
        
            
          
      }
    },
    Get() {
      this.ActionsFilterGet({
        Service: "satdosyafirma",
        "Page":this.Page,"Filter":"&Dosyaid="+this.satdosyaId+"&Firmaturu=1"
      }).then((res) => { 
        this.SatDosyaFirma=[]
        this.ComboDataArray=[]
        this.SatDosyaFirma = res.Data
        for(var i=0; i<res.Data.length; i++)
          {        
              let Kosul = this.FirmasData.filter((notification) =>notification.Firmaid.includes(res.Data[i].Firmaid))
              if(Kosul.length === 0)
                {
                  this.ComboDataArray.push ({id:res.Data[i].Firmaid,label:res.Data[i].Firmaadi})
                }
          }
      });
      this.ActionsFilterGet({
        Service: "satdosyafirmafiyat",
        "Page":this.Page,"Filter":"&Dosyaid="+this.satdosyaId+"&Fiyatturu=1"
      }).then((res) => { 
        this.FirmaFiyat=[]
         this.FirmaFiyat = res.Data
      });
    }, 
  },
}; 
</script>
<template>
  <Loader>
    <b-modal
      id="yaklasikmaliyettenaktar"
      size="xl"
      :title="$t('yaklasikmaliyettenaktar.Title')"
      title-class="font-18"
      hide-footer
    >
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body"> 

              <Form @submit.prevent="onSubmit">   
                
             <b-form-group class="mb-3" id="example text"  :label="$t('yaklasikmaliyettenaktar.AddEdit.YaklasikMaliyettekiFirmalar')" label-for="text">
              <treeselect
              :multiple="true"
              :options="ComboDataArray"
        :placeholder="$t('OrtakKullanim.seciniz')"
              v-model="Firmalar" 
                :class="{ 'is-invalid': $v.Firmalar.$error }"
              />
              <treeselect-value :value="Firmalar" />
                
                  <div v-if="$v.Firmalar.$error" class="invalid-feedback"> 
              <span v-if="$v.Firmalar.required == false">{{  $t("ValidationMessage.required") }}</span> 
            </div>
            </b-form-group>
                
                      <button 
           
                      class="btn btn-primary" type="submit">
                        {{ $t("yaklasikmaliyettenaktar.AddEdit.Button") }}
                      </button>
                
              </Form>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </Loader>
</template>
